import moment from 'moment/moment';
import {getCurrentCruisesFromStore} from "../actions/cruisesActions";
import { t } from "@lingui/core/macro";

export function flattenExcursions(cartElements, cruiseStartDateString = null) {
    let excursions = [];

    if(!cartElements) {
        return excursions;
    }

    const startDate = cruiseStartDateString ? moment(cruiseStartDateString, 'DD/MM/YYYY') : null;

    for (const itineraryId in cartElements) {
        for (const excursionId in cartElements[itineraryId]) {
            const hasExcursionId = cartElements[itineraryId][excursionId].excursionId;

            // in case of bookings there might be 3rd level of nesting: itineraryId->excursionId->bookingStatus
            // if there is excursionId present on the element we have reached the node already so only iterate once
            // "SingleArrayElement" can be any string, it's just a placeholder, ensuring the loop below will run exactly once
            const types = cartElements[itineraryId][excursionId].excursionId ? ["SingleArrayElement"] : Object.keys(cartElements[itineraryId][excursionId])

            for(const type of types) {
                const excursionInfo = hasExcursionId ?
                    {...cartElements[itineraryId][excursionId]}:
                    {...cartElements[itineraryId][excursionId][type]};

                if(startDate) {
                    const dayNr = moment(cartElements[itineraryId][excursionId].date, 'DD/MM/YYYY').diff(startDate, 'days') + 1
                    excursionInfo.dayNr = dayNr;
                }

                excursions.push(excursionInfo);
            }
        }
    }

    return excursions;
}

export function flattenTacEntries(tacEntries, cruiseStartDateString = null) {
    if(!tacEntries) {
        return [];
    }

    if(cruiseStartDateString === null) {
        const currentCruises = getCurrentCruisesFromStore();
        if(!currentCruises) {
            return [];
        }

        cruiseStartDateString = currentCruises.cruiseStartDate;
    }
    if(!cruiseStartDateString) {
        return [];
    }

    const startDate = moment(cruiseStartDateString, 'DD/MM/YYYY');

    //push all of the entries to single array and attach the date and day information
    let entries = [];
    for (const date in tacEntries) {
        if (tacEntries.hasOwnProperty(date)) {
            const dayNr = moment(date, 'DD/MM/YYYY').diff(startDate, 'days') + 1;
            const tacEntriesForDate = tacEntries[date].map(entry => {
                entry.dayNr = dayNr;
                entry.date = date;
                return entry;
            });

            entries.push(...tacEntriesForDate);
        }
    }

    return entries;
}

export function groupExcursionsByState(cartElements) {
    let excursions = {};

    if(!cartElements) {
        return excursions;
    }

    for (const itineraryId in cartElements) {
        for (const excursionId in cartElements[itineraryId]) {
            const excursionInfo = {...cartElements[itineraryId][excursionId]};

            if(!excursions[excursionInfo.status]) {
                excursions[excursionInfo.status] = [excursionInfo];
            }
            else {
                excursions[excursionInfo.status].push(excursionInfo);
            }
        }
    }

    return excursions;
}

export function priceWithTwoDecimals(price) {
    return parseFloat(price).toFixed(2);
}

export function mergeAndSortExcursionAndTacEntries(excursions, tacEntries, cruiseStartDate) {
    const combinedEntries = [...flattenExcursions(excursions, cruiseStartDate), ...flattenTacEntries(tacEntries, cruiseStartDate)];

    combinedEntries.sort(
        function(a, b) {
            if (a.dayNr === b.dayNr) {
                // 2 excursions or 2 restaurants return 0
                if((a.excursionId && b.excursionId) || (!a.excursionId && !b.excursionId)) {
                    return 0;
                }

                // excursions go before restaurants on same day
                return a.excursionId ? -1 : 1;
            }

            // "smaller" days go first
            return a.dayNr > b.dayNr ? 1 : -1;
        });

    return combinedEntries;
}

export function getDayNr(date, cruiseStartDateString = null) {
    if(!cruiseStartDateString) {
        return 0;
    }
    const startDate = moment(cruiseStartDateString, 'DD/MM/YYYY');

    return moment(date, 'DD/MM/YYYY').diff(startDate, 'days') + 1;
}

export function priceWithCurrency(currencySymbol, price) {
    return currencySymbol === "€" ? `${price}${currencySymbol}` : `${currencySymbol}${price}`;
}

export function formatAddToPlannerPrice(adultPrice, childPrice, minAge, currencySymbol) {
    let priceText = `${priceWithCurrency(currencySymbol,adultPrice)} ${t({id: "per_adult"})}`;
    if(childPrice) {
        let childAgeRange = getChildAgeRange();
        if(minAge && minAge > 2) {
            childAgeRange = `(${minAge}-12)`;
        }
        priceText += `, ${priceWithCurrency(currencySymbol,childPrice)} ${t({id: "per_child"})} ${childAgeRange}`;
    }
    return priceText;
}


export function getChildAgeRange(wrapInParenthesis = true) {
    return wrapInParenthesis ? "(3-12)" : "3-12";
}